'use client'

import Image from 'next/image'

import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink'
import type { TopNavV6Violator } from '@src/components/TopNavV6/TopNavV6Props'
import { useTrackSelectNavCta } from '@src/utils/analytics.util'

export const TopNavV6Tile = (props: { tile?: TopNavV6Violator }) => {
  const { tile } = props
  const trackSelectNavCta = useTrackSelectNavCta()

  const content = (
    <>
      <div className="relative mb-2 aspect-3/2 w-full overflow-hidden rounded-[30px] bg-bodi-gray-medium">
        {tile?.image && (
          <Image className=" object-cover" src={tile.image} alt={tile?.alt ?? ''} fill />
        )}
      </div>
      {tile?.stamp && <div className="w-fit text-bodi-green-bright-500">{tile.stamp}</div>}
      <div className="w-fit text-white">{tile?.title}</div>
    </>
  )

  if (tile?.href) {
    return (
      <LocalizedLink
        rel={tile?.newTab ? 'noopener noreferrer' : ''}
        target={tile?.newTab ? '_blank' : '_self'}
        href={tile.href}
        className="w-full font-medium"
        onClick={() => {
          trackSelectNavCta({ 'cta url': tile.href })
          tile?.onClick?.()
        }}
      >
        {content}
      </LocalizedLink>
    )
  }

  return (
    <div
      className="w-full font-medium"
      onClick={() => {
        tile?.onClick?.()
      }}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && tile?.onClick) {
          e.preventDefault()
          tile.onClick()
        }
      }}
      role={tile?.onClick ? 'button' : undefined}
      tabIndex={tile?.onClick ? 0 : undefined}
    >
      {content}
    </div>
  )
}
